// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3Qo6o","content":"Consent_content__KTsaw","footer":"Consent_footer__uxQby"};